import { FunctionComponent } from "react";
import { ComponentIconOption } from "../../../lib/ssi/form.types";
import { ComponentId } from "../../../lib/types/ids";
import { resolveStaticPath } from "../../../lib/types/static-path";
import { Heading } from "../Text/Heading";

export interface IconOptionBoxProps extends ComponentIconOption {
  onSelect: () => void;
  questionId: string;
  isSelected?: boolean;
}

const IconOptionBox: FunctionComponent<IconOptionBoxProps> = ({
  id,
  children,
  heading,
  description,
  icon,
  label,
  note,
  isSelected,
  onSelect,
  disabled,
}) => {
  const hasChildren = Array.isArray(children) && children.length > 0;
  console.log(children);
  return (
    <div
      className={`flex flex-col relative justify-between py-10 px-8 border-gray-300 items-start border rounded-multiple-choice w-full text-left h-full component ${disabled ? "cursor-default" : "cursor-pointer"
        } ${isSelected ? "border-primary bg-primary-light" : ""}`}
      onClick={() => onSelect()}
      data-id={ComponentId.encode(id)}
    >
      {disabled ? (
        <div className="absolute top-0 bottom-0 right-0 left-0 bg-gray-200 opacity-75 z-50 p-2">
          <p className="text-center font-semibold">Aktuell nicht verfügbar</p>
        </div>
      ) : null}
      <div>
        <img src={resolveStaticPath(icon)} height="48px" width="48px" className="mb-4" />
        <Heading level={5} className="mb-2">
          {heading}
        </Heading>
        <p className="text-sm">{description}</p>
        <ul className={`${hasChildren ? "mb-2 mt-8" : ""}`}>{children}</ul>
      </div>
      {(label || note) && (
        <Heading level={2} className="flex items-end w-full justify-self-end text-3xl text-primary font-bold label-container">
          <p className="text-2xl text-primary font-bold mt-6 label">
            {label}{" "}
            <span className="text-base font-normal text-gray-500 label-note">{note}</span>
          </p>
        </Heading>
      )}
    </div>
  );
};

export default IconOptionBox;
